import {
  PaymentRequestForm,
  TransactionProperty,
} from '@/features/InvoiceReport/Edit/type';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import {
  DATE_FORMAT,
  DATE_FORMAT_MONTH,
  DatepickerProps,
  FormDatepicker,
} from '@moneyforward/ap-frontend-components';
import { memo, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

type Props = {
  index: number;
  property: TransactionProperty;
};

const InnerDateTypeInput = ({ index, property }: Props) => {
  const { control } = useFormContext<PaymentRequestForm>();
  const { placeholder, dateFormatType, id } = property;
  //TODO: Can be changed to use the masterFieldName depending on the API
  const fieldName =
    `invoiceTransactions.${index}.custom_transaction_items.${id}` as const;
  const containerRef = useGlobalContainerRef();

  const datepickerProps = useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
      placeholder: placeholder,
      picker: dateFormatType === 'year_month' ? 'month' : 'date',
      format: dateFormatType === 'year_month' ? DATE_FORMAT_MONTH : DATE_FORMAT,
      inputReadOnly: false,
      getPopupContainer: containerRef,
    } as DatepickerProps;
  }, [placeholder, dateFormatType, containerRef]);

  return (
    <FormDatepicker<PaymentRequestForm>
      control={control}
      name={fieldName}
      inputId={`${id}${index}`}
      single
      datepickerProps={datepickerProps}
    />
  );
};
InnerDateTypeInput.displayName = 'InnerDateTypeInput';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const DateTypeInput = memo(
  InnerDateTypeInput
) as typeof InnerDateTypeInput;
DateTypeInput.displayName = 'DateTypeInput';
